import React from "react"
import CategoryIcon from "../icons/category-icon"
import Link from "../link"
import cn from "../../utils/classname"

export default function CategoryCard({
  name,
  info,
  slug,
}: {
  name: string
  info: string
  slug: string
}) {
  return (
    <Link
      className={cn(
        "snap-center",
        "bg-neutral-2 p-2 rounded-2xl hover:bg-neutral-alpha-3  active:shadow-1 cursor-pointer",
        "flex items-center gap-4 w-[328px] sm:w-full shrink-0"
      )}
      to={`/premium/library/all/${slug}/`}
      external
    >
      <div className="flex items-center justify-center rounded-[14px] p-3 bg-neutral-alpha-3 shrink-0">
        <CategoryIcon group={`ColorIcons`} icon={slug} className="size-8" />
      </div>
      <div className="flex flex-col shrink-0">
        <div className="font-medium text-neutral-12 text-jar-4">{name}</div>
        <div className="text-neutral-11 text-jar-3 mt-0.5">{info}</div>
      </div>
    </Link>
  )
}
